// extracted by mini-css-extract-plugin
export var breadcrumb = "_1a-2";
export var breadcrumbArrow = "_1a-3";
export var breadcrumbs = "_1a-0";
export var link = "_1a-4";
export var small = "_1a-1";